<template>
    <!-- <div id="group" class="vs-con-loading__container" v-if="config.gocheckin_feature == 1"> -->
    <div id="group" class="vs-con-loading__container" v-if="1">
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
          <li class="inline-flex items-end">
              <router-link to="/after-login">
                  <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
              </router-link>
              <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
          </li>
          <li class="inline-flex items-end">
            <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Group</span>
          </li>
      </ul>
    </div>
      <h2 class="my-6 py-6 font-bold">Manage Groups</h2>
      <div class="mb-6 flex align-start">
          <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current"/>
          <span class="ml-4 d-inline-block">You can create your own customer groups here. For example Favorite Customers Group, Customers need more attention Group, etc. When you create a promotion, you can include or exclude those groups from the promotion.</span>
      </div>

      <div class="w-full md:flex flex-wrap mb-base">
          <div class="flex justify-center md:w-1/2" v-for="(group, index) in groupsList" :key="index" @click="updateGroup(group)">
              <vx-card class="w-11/12 my-3 shadow-md">
                  <div class="h-full flex justify-between align-center">
                      <div class="break-word">{{index + 1}}. {{group.name}}</div>
                      <div class="flex-center" style="min-width: 95px;">
                          <!-- <feather-icon icon="Edit2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="popupUpdateActive = true"/> -->
                          <img src="../../assets/images/pen-icon.png" class="cursor-pointer ml-5 pen-icon" @click="popupUpdateActive = true" />
                          <!-- <feather-icon icon="Trash2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="popupDeleteActive = true"/> -->
                          <img src="../../assets/images/trash-icon.png" class="cursor-pointer ml-5 trash-icon" @click="popupDeleteActive = true" />
                          <router-link :to="{path: 'group/group_info?id=' + group.id + '&name=' + group.name, params: {groupInfo: group}}" :key="group.id" class="group-info-icon">
                            <!-- <feather-icon icon="SettingsIcon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group"/> -->
                            <img src="../../assets/images/setting-icon.png" class="ml-5 setting-icon" />
                          </router-link>
                          <!-- <vs-button :to="{name: 'group_info', params: {groupInfo}}">abc</vs-button> -->
                      </div>
                  </div>
              </vx-card>
          </div>

          <div class="flex justify-center md:w-1/2">
                <vx-card class="w-11/12 my-3 plus-card cursor-pointer shadow-md" @click="popupAddActive = true">
                  <div class="h-full flex justify-center align-center">
                      <!-- <feather-icon icon="PlusIcon" svgClasses="w-10 stroke-current icon-plus"/> -->
                      <img src="../../assets/images/plus-icon.png" class="plus-icon" />
                  </div>
              </vx-card>
              <vs-popup class="holamundo create-group create-popup" title="Create New Group" :active.sync="popupAddActive">
                  <div>
                      <vs-input label="Name" :maxlength="30" v-validate="'required'" name="add_group_name" v-model="add_group_name" class="w-full" :danger="errors.has('add_group_name')"
                      danger-text="The group name field is required" />
                      <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                          <vs-button class="mr-6 align-center save-responsive" @click="saveAddGroup">Save</vs-button>
                          <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
                      </div>
                  </div>
              </vs-popup>
          </div>
      </div>
      <!-- Update popup -->
      <vs-popup class="holamundo edit-group edit-popup" title="Edit Group" :active.sync="popupUpdateActive">
          <div>
              <vs-input label="Name" :maxlength="30" v-validate="'required'" name="group_name" v-model="group_name" class="w-full" :danger="errors.has('group_name')"
              danger-text="The group name field is required"/>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                  <vs-button class="mr-6 align-center save-responsive" @click="saveEditGroup">Save</vs-button>
                  <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
              </div>
          </div>
      </vs-popup>
      <!-- Delete popup -->
      <vs-popup class="holamundo delete-group delete-popup" title="Delete Group" :active.sync="popupDeleteActive">
          <div class="text-center">
              <h3>Do you want to delete this group?</h3>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
              <vs-button class="mr-6 align-center delete-responsive" @click="deleteGroup">Delete</vs-button>
              <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
              </div>
          </div>
      </vs-popup>
      <div v-if="groupsData._meta.pageCount">
          <!-- <vs-pagination class="custom-pagination" :total="parseInt(groupsData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
          <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(groupsData._meta.pageCount)"
          :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
      </div>
    </div>
    <div v-else>
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
    </div>
</template>

<script>
    export default {
        // props: {
        //   dataChange: {
        //     type: Object
        //   }
        // },
        name: 'my-group',
        data() {
            return {
                popupUpdateActive: false,
                popupAddActive: false,
                popupDeleteActive: false,
                name : '',
                add_group_name: '',
                id: 0,
                check: true,
                groupInfo: {},
                currentPage: 1,
                itemsPerPage: 9,
                items: [
                  {
                    title: 'Home',
                    url: '/',
                    icon: "HomeIcon",
                  },
                  {
                    title: 'Group',
                    active: true,
                  },
                ],
                action_type: '',
                isOpenLoading: false,
                page_key: 0,
                loaded_data_num: 0
            }
        },
        computed: {
            groupsList() {
                return this.$store.getters["customerList/groupList"];
            },
            groupsData() {
                return this.$store.getters["customerList/groupData"];
            },
            group_name: {
                get() {
                    return this.name;
                },
                set(value) {
                    this.name = value;
                }
            },
            config() {
                return this.$store.getters["auth/config"];
            }
        },
        watch: {
        //   dataChange: {
        //     immediate: true,
        //     deep: true,
        //     handler: function () {
        //     //   if(this.dataChange) {
        //     //     console.log(this.dataChange.message);
        //     //   }
        //       // if(this.dataChange && this.dataChange.message == 'afterInsert') {
        //       if(this.dataChange) {
        //         const obj = {
        //             page: this.currentPage,
        //             "per-page": this.itemsPerPage
        //         }
        //         this.$store.dispatch("customerList/GET_GROUP_LIST", obj)
        //       }
        //     },
        //   },
          popupAddActive: {
            immediate: true,
            deep: true,
            handler() {
              this.add_group_name = '';
              // this.errors = [];
              this.errors.clear();
            }
          },
          popupUpdateActive: {
            immediate: true,
            deep: true,
            handler() {
            //   this.name = '';
              // this.errors = [];
              this.errors.clear();
            }
          },
          loaded_data_num: {
            immediate: true,
            handler() {
              if(this.loaded_data_num >= 1) {
                this.closeLoading();
              } else {
                this.action_type = "Get data";
                this.openLoadingInDiv();
              }
            }
          }
        },
        methods: {
          openLoadingInDiv(){
            this.$vs.loading({
              container: '#app',
              scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    // this.$vs.notify({
                    //     title:'Notification',
                    //     text: this.action_type + ' group failed',
                    //     color:'danger',
                    //     position:'top-right'})
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + ' group failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
            // setTimeout( ()=> {
            //   this.$vs.loading.close('#staff-list > .con-vs-loading')
            // }, 500);

          },
          closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
          },
          changePage(currentPage) {
              this.openLoadingInDiv();
                const obj = {
                    page: currentPage,
                    "per-page": this.itemsPerPage,
                    // search: this.search
                }
                // console.log('........................');
                // console.log(currentPage);
                this.action_type = "Get list";
                this.$store.dispatch("customerList/GET_GROUP_LIST", obj).then(() => {
                    this.closeLoading();
                    this.currentPage = currentPage;
                    this.page_key++;
                })
            },
            updateGroup(group){
                this.name = group.name;
                this.id = group.id;
                this.group = {
                    id: this.id
                }
            },
            checkAlreadyName(name, id){
              for(let i = 0; i< this.groupsList.length; i++){
                if(name.trim() == this.groupsList[i].name.trim() && id != this.groupsList[i].id){
                  this.check = false;
                }
              }
            },
            saveEditGroup() {
                if(this.name != '') {
                  const obj = {
                    id: this.id,
                    name: this.name,
                    page: this.currentPage,
                    "per-page": this.itemsPerPage,
                  }
                  this.checkAlreadyName(this.name, this.id)
                  this.action_type = "Update";
                  if(this.check == true){
                    this.openLoadingInDiv();
                    this.$store.dispatch('customerList/UPDATE_A_GROUP', obj).then(() => {
                        this.closeLoading();
                        this.closePopup();
                        this.$vs.notify({
                            title:'Notification',
                            text:'Update Group Name Success',
                            color:'success',
                            position:'top-right'})
                    }).catch(() => {
                        this.closeLoading();
                        this.closePopup();
                    })
                  }else{
                    this.closeLoading();
                    // this.closePopup();
                    this.check = true;
                    this.$vs.notify({
                      title:'Notification',
                      text: this.name + ' has already existed',
                      color:'danger',
                      position:'top-right'})
                      // this.name= '';
                  }
                }
            },
            deleteGroup() {
                const obj = {
                    id: this.id,
                    page: this.currentPage,
                    "per-page": this.itemsPerPage,
                }
                this.action_type = "Delete";
                this.openLoadingInDiv();
                this.$store.dispatch('customerList/DELETE_A_GROUP', obj).then(() => {
                    this.closeLoading();
                    this.closePopup();
                    this.$vs.notify({
                        title:'Notification',
                        text:'Delete Group Success',
                        color:'danger',
                        position:'top-right'})
                }).catch(() => {
                    this.closeLoading();
                    this.closePopup();
                })
            },
            saveAddGroup() {
                if(this.add_group_name != '') {
                    const obj = {
                        name: this.add_group_name,
                        page: this.currentPage,
                        "per-page": this.itemsPerPage,
                    }
                    this.action_type = "Add";
                    this.checkAlreadyName(this.add_group_name)
                    if(this.check == true){
                      this.openLoadingInDiv();
                      this.$store.dispatch('customerList/CREATE_A_GROUP', obj).then(() => {
                          this.closeLoading();
                          this.closePopup();
                          this.$vs.notify({
                              title:'Notification',
                              text:'Add Group Success',
                              color:'success',
                              position:'top-right'})
                          this.add_group_name = '';
                      }).catch(() => {
                          this.closeLoading();
                          this.closePopup();
                      })
                    }else{
                      this.closeLoading();
                      this.check = true;
                      this.$vs.notify({
                        title:'Notification',
                        text: this.add_group_name + ' has already existed',
                        color:'danger',
                        position:'top-right'})
                    }
                }
                this.$validator.validateAll();
            },
            closePopup() {
                this.popupUpdateActive = false;
                this.popupAddActive = false;
                this.popupDeleteActive = false;
            }
        },
        created() {
          const obj ={
            page: this.currentPage,
            "per-page": this.itemsPerPage
          }
          this.$store.dispatch("customerList/GET_GROUP_LIST",obj).then(() => {
            this.loaded_data_num++;
          })
        }
    }
</script>